import { render } from "./RiRefresh.vue?vue&type=template&id=2fa361c4"
import script from "./RiRefresh.vue?vue&type=script&lang=js"
export * from "./RiRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiRefresh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fa361c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fa361c4', __exports__)) {
    api.reload('2fa361c4', __exports__)
  }
  
  module.hot.accept("./RiRefresh.vue?vue&type=template&id=2fa361c4", () => {
    api.rerender('2fa361c4', render)
  })

}


export default __exports__